module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-3-photo-5-e81449a99764f8fd4a91579aeae5946c.webp";